import { AxiosHttpPost } from 'axios-http';
import { OrderDTO } from 'models/spareParts/orderById';
import { SPARE_PARTS } from 'resources/links';

export function processOrder(body: OrderDTO) {
    return AxiosHttpPost({ url: SPARE_PARTS.processOrder, data: body });
}
